module.exports = __webpack_public_path__ + "images/zorgenzekerheid0ef1626b7943e30963b82d11436456cb.png";